
import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box, CardMedia } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AudioPlayer from 'react-h5-audio-player';
import ReactPlayer from 'react-player';
import { resolveVideoPreview } from '../../network/cloudflare_stream_service/CloudflareStream_api_callback';


const MediaPreviewDialog = ({ open, onClose, multimedia }) => {
  const videoPreview = resolveVideoPreview(multimedia);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Preview
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {multimedia?.mediaType === 'image' && (
          <CardMedia
            component="img"
            image={multimedia?.url}
            alt="Preview Image"
            sx={{ width: '100%', maxHeight: 400, objectFit: 'contain' }}
          />
        )}
        {multimedia?.mediaType === 'audio' && (
          <AudioPlayer
            src={multimedia?.url}
            layout="horizontal"
            showJumpControls={false}
            showDownloadProgress={false}
            customAdditionalControls={[]}
            customVolumeControls={[]}
            style={{ marginTop: 10 }}
          />
        )}
        {multimedia?.mediaType === 'video' && (
          <Box sx={{ mt: 2 }}>
            {videoPreview.type === 'cloudflare' || videoPreview.type === 'vimeo' ? (
              <iframe
                src={videoPreview.embedUrl}
                width="100%"
                height="300px"
                style={{ border: 0 }}
                allow="autoplay; fullscreen; picture-in-picture"
                frameBorder="0"
                allowFullScreen={false}
              />
            ) : (
              <ReactPlayer
                url={videoPreview.url}
                controls
                width="100%"
                height="300px"
              />
            )}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default MediaPreviewDialog;
